<template>
  <div class="sufee-login d-flex align-content-center flex-wrap">
    <div class="container">
      <div class="w100 text-right">
        <BtnFullScren>
          <button type="button" class="btn btn-primary btn-smX btn-fullScren">
            <i class="fa fa-arrows-alt"></i>
          </button>
        </BtnFullScren>
        &nbsp;

        <BtnExit>
          <button type="button" class="btn btn-danger btn-smX btn-exit">
            <strong>X</strong>
          </button>
        </BtnExit>
      </div>

      <div class="login-content">
        <!--<div class="login-logo">-->
        <!--<a href="index.html">-->
        <!--<img class="align-content" src="assets/logo.png" alt="">-->
        <!--</a>-->
        <!--</div>-->

        <div class="login-form">
          <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
          <!--<form>-->
          <div class="form-group">
            <label>{{$t('login.language')}}</label>
            <LngChooser :bgWhite="'true'"/>
          </div>
          <div class="form-group">
            <label>{{$t('selectstore.title')}}</label>
          </div>
          <br>
          <template v-if="canSelect">

          <div class="form-group">
            <label>{{$t('selectstore.selectstore')}}</label>
            <select id="id_store" class="form-control" v-model="data.store" name="id_store">
              <option value="">{{$t('global.notset')}}</option>
              <option v-for="store in stores" :value="store.id">{{store.text}}</option>
            </select>
          </div>
          <div class="checkbox">
            <!--<label>-->
            <!--<input type="checkbox"> Remember Me-->
            <!--</label>-->
            <label class="pull-right">
              <!--<router-link to="/forgottenpassword" tag="a" class="">{{$t('login.forgottenpassword')}}</router-link>-->
            </label>

          </div>
          <button v-on:click="ok()" class="btn-login btn btn-success btn-flat m-b-30 m-t-30">{{$t('selectstore.submit')}}</button>

          </template>
          <template v-if="!canSelect">

          </template>
          <!--<div class="social-login-content">-->
          <!--<div class="social-button">-->
          <!--<button type="button" class="btn social facebook btn-flat btn-addon mb-3"><i class="ti-facebook"></i>Sign in with facebook</button>-->
          <!--<button type="button" class="btn social twitter btn-flat btn-addon mt-2"><i class="ti-twitter"></i>Sign in with twitter</button>-->
          <!--</div>-->
          <!--</div>-->
          <!--<div class="register-link m-t-15 text-center">-->
          <!--<p>Don't have account ? <a href="#"> Sign Up Here</a></p>-->
          <!--</div>-->
          <!--</form>-->
        </div>
      </div>
    </div>
  </div>


</template>


<script>
  import Api from '@/api/Api';
  import LngChooser from '@/components/LngChooser.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Helper from '@/helper/Helper';
  import BtnFullScren from "@/components/BtnFullScren";
  import BtnExit from "@/components/BtnExit";

  export default {
    name: 'SelectStore',
    data() {
      return {
        data: {
          store: ""
        }
        , stores: []
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        },
        canSelect: false,

      };
    },
    mounted() {
      const modul = this;
//      if (localStorage) {
//        modul.data.store = localStorage.getItem("store");
//      }
      modul.data.store = modul.$store.state.store;
      if (modul.data.store) {
        // Ide lehet egy store lekérdezést, és kiírni.. felülre. -- vagy ezt másra bízni.
        const id = modul.data.store;
        modul.getStore(function (err, res) {
          if (!err && res.id) {
            modul.$router.push({name: "sellinone"})
          } else {
//            modul.data.store = localStorage.removeItem("store");
            modul.getStores(function (err, res) {
              if (!err) {
                if (Array.isArray(res)) { //  res[0] &&
                  modul.canSelect = true;
                  modul.stores = res;
                }
              }
            });
          }
        }, id);
      } else {
        modul.getStores(function (err, res) {
          if (!err) {
            if (Array.isArray(res)) { //  res[0] &&
              modul.canSelect = true;
              modul.stores = res;
            }
          }
        });
      }
      // TODO -- Need fix setting handling, if it is neccessary
//      modul.$eventBus.$emit('SettingSetter', res);
    },
    methods: {
      makeStrStore(){
        const modul = this;
        let strCompany = "";
        Array.prototype.forEach.call(modul.stores, function (e, x) {
          if (modul.$store.state.store && e.id === modul.$store.state.store) {
            strCompany = e.text;
          }
        })
        modul.strCompany = strCompany;
      },

      getStore: function (cb, id) {
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getStore({id: id}).then(function (e) {
          modul.AlertInPage.msg = "";
          if (e && e.result === true) {
            console.log(e)
            cb(null, e.data);
          }
        }, function (err) {
          modul.AlertInPage.msg = "form.texterrorserver";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          console.log(err)
          cb(err, null);
        });
      },
      getStores: function (cb) {
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getStores({is_active:1}).then(function (e) {
          modul.AlertInPage.msg = "";
          if (e && e.result === true) {
            console.log(e)
            cb(null, e.data);
          }
        }, function (err) {
          modul.AlertInPage.msg = "form.texterrorserver";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          console.log(err)
          cb(err, null);
        });
      },
      ok: function () {
        const modul = this;
        if (localStorage && modul.data.store) {
            // TODO -- elmentjük a gépet! -- utána rakjuk localstorage-ba, -- utána jezünk vissza, és irányítunk máshova!

          // TODO  -- loginkor létre kell hozni a gépet NULL-lal, és addig nem mehet továbbmíg nincs a workstation táblában store !

          // Save Store And MakeWorkstation

          const cb=function (err, res) {
              const e=res;
            if (e && e.result === true) {

            modul.$store.state.company = e.company;
            modul.$store.state.store = e.store;
            modul.$store.state.companyname = e.companyname;
            modul.$store.state.storename = e.storename;
            modul.$store.state.user = e.user;

              modul.makeStrStore();
//            localStorage.setItem("store", modul.data.store);

//            if (localStorage) {
//              modul.data.store = localStorage.getItem("store");
//            }
//            if (modul.data.store) {
              // Ide lehet egy store lekérdezést, és kiírni.. felülre. -- vagy ezt másra bízni.
              modul.AlertInPage.msg = "form.process_succes";
              modul.AlertInPage.type = "success";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
                // Redirect
                console.log("redirect sellinone");


                modul.$router.push({name: "sellinone"})


              }, Number(1000));

            } else {
              modul.AlertInPage.msg = "form.save_error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(5000));

            }

          };




          const data={};
          data.id=modul.data.store;
          data.wsid = localStorage.getItem("browserIdentifier");

          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";
          Api.saveStoreAndMakeWorkstation(data).then(function (res) {
            modul.AlertInPage.msg = "";
            if (res && res.result === true) {
              console.log(res)
              cb(null, res);
            }
          }, function (err) {
            modul.AlertInPage.msg = "form.texterrorserver";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(5000));
            console.log(err)
            cb(err, null);
          });



        }


      },

    },
    components: {
      LngChooser
      , AlertInPage
      , BtnExit
      , BtnFullScren
    },
  };
</script>

